// extracted by mini-css-extract-plugin
export default {"numberContainer":"AtGWh","numberWrapper":"KOhYu","number":"GyxUt","numberTitle":"XzaH1","icon":"zZF1Y","numberDescription":"wsgv5","container":"YXy4l"};